module.exports = __webpack_public_path__ + "static/media/0a5d7b2f-e084-43be-bc0d-f8fc267b30c8.f3940f20.JPG";